import React from 'react'
import "./sectionSecurityAndManagement.scss"

//Imagens:
import ImgSectionSecurityAndManagement from "../../../assets/securityAndManagement/sectionSecurityAndManagement.png"
import { useTranslation } from 'react-i18next'

function SectionSecurityAndManagement() {

  const { t } = useTranslation()


  return (
    <div className='container-section-security-and-management'>
      <div className='img-section-security-and-management'>
        <img src={ImgSectionSecurityAndManagement} alt="" />
      </div>
      <div className='texts-section-security-and-management'>
        <h1>{t("user_security_and_management.title")}</h1>
        <p>{t("user_security_and_management.section_text")}</p>
        <a href="/form" style={{ textDecoration: "none" }}>
          <button id='btn-section-security-and-management'>{t("buttons.demo_btn_alternative_text_1")}</button>
        </a>
      </div>
    </div>
  )
}

export default SectionSecurityAndManagement
